// extracted by mini-css-extract-plugin
module.exports = {"lockedMessageFader":"LockedMessage_lockedMessageFader__5Oc8x","lockedMessageLock":"LockedMessage_lockedMessageLock__29YAt"};